import FormList from "@/components/Forms/FormList.vue";
import FormEdit from "@/components/Forms/FormEdit.vue";

const FormRoutes = [
    {
        path: "/forms",
        name: "FormList",
        components: {
            page: FormList
        }
    },
    {
        path: "/form/edit/:id",
        name: "FormEdit",
        components: {
            page: FormEdit
        }
    }
];

export default FormRoutes;
